module.exports = __webpack_public_path__ + "images/interview-Visa-2.svg";